import { store } from "../../redux/store";
import { setItem } from "./data";
import JigsawAPI from "../../services/jigsaw";
import { toastUtils } from "../../utils/toast-utils";
import { selectors as brandSelectors } from "../../redux/brand";
import { t } from "../core/translate";

// DUPLICATE, use redux/router/utils
export const _getURL = url => {
  try {
    return new URL(url);
  } catch (error) {
    // ie11
    var href = document.createElement("a");
    href.href = url;
    return href;
  }
};

const _getDomain = host => {
  if (host.length === 0) {
    return "";
  }

  var hostParts = host.split(".").reverse();
  if (hostParts.length >= 3) {
    let tldReg = /^(com|edu|gov|net|mil|org|nom|co|name|info|biz|uk|is|ca)$/i;
    if (hostParts[1].match(tldReg) && hostParts[0].match(tldReg)) {
      return `${hostParts[2]}.${hostParts[1]}.${hostParts[0]}`;
    }
  }
  return `${hostParts[1]}.${hostParts[0]}`;
};

const _getHostname = url => _getURL(url).hostname;

const _getProtocol = url => _getURL(url).protocol;

const _allowlistDomain = [
  "",
  "undefined.bookshelf",
  "vitalsource.com",
  "vitalsource.co.uk",
  "vitalbook.com",
  "cengage.com",
  "phoenix.edu",
  "minhabiblioteca.com.br",
  "gilmoreglobal.com",
  "digitalcontenthelp.com",
  "editoraatlas.com.br",
  "yuzu.com",
  "bncollege.com",
  "bookrenter.com",
  "bookrenterstore.com",
  "itdepartment.nl",
  "studystore.nl",
  "brownmackie.edu",
  "brytewave.com",
  "ccl.org",
  "vsapplications.com",
  "clever.com",
  "lww.com",
  "devryu.net",
  "edx.org",
  "coursewareobjects.com",
  "elsevier.com",
  "gsionline.com.br",
  "senac.br",
  "heimkaup.is",
  "digitalcontenthelp.com",
  "gwinnett.k12.ga.us",
  "learningfield.com.au",
  "mandrelworks.com",
  "bookrenter.com",
  "bookmarkonline.co.za",
  "bookshelf.nl",
  "sideriscourseware.com",
  "studieboekencentrale.nl",
  "textbooks.com",
  "vanschaik.com",
  "xlibrio.zendesk.com",
  "xlibrio.com",
  "vsapplications.com",
  "vstbridge.com",
  "cengagebrain.com",
  "onedrive.live.com",
  "google.com",
  "apple.com",
  "itunes.com",
  "chegg.com",
  "www.chegg.com",
  "miheexplorers.com",
  "follett.com",
  "clinicalkey.com",
  "td.org"
];

const _allowListedProtocols = [
  "http:",
  "https:",
  "vbk:",
  "bned:",
  "itms-apps:"
];

export const addParameter = (url, parameter, value) => {
  parameter = encodeURIComponent(parameter);
  value = encodeURIComponent(value);

  if (url.indexOf("?") === -1) {
    return url + "?" + parameter + "=" + value;
  } else {
    var parts = url.split("?");
    return parts[0] + "?" + parameter + "=" + value + "&" + parts[1];
  }
};

export const replaceUrlParam = (url, paramName, paramValue) => {
  //https://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery
  if (!paramValue) {
    paramValue = "";
  }
  const pattern = new RegExp("\\b(" + paramName + "=).*?(&|#|$)");
  if (url.search(pattern) >= 0) {
    return url.replace(pattern, "$1" + paramValue + "$2");
  }
  url = url.replace(/[?#]$/, "");
  return (
    url + (url.indexOf("?") > 0 ? "&" : "?") + paramName + "=" + paramValue
  );
};

export const ltiLaunch = (user, type, newtab, roles, params = {}) => {
  const userExists =
    (user && user.email) || (Fraction.User && Fraction.User.email);

  if (userExists) {
    if (newtab) {
      let redirectUrl = "/#/redirect/lti";
      params.lti = true;
      params.type = type;
      params.roles = roles;
      for (let i = 0; i < Object.keys(params).length; i++) {
        const paramKey = Object.keys(params)[i];
        const paramVal = params[Object.keys(params)[i]];
        if (paramKey && paramVal) {
          redirectUrl = Fraction.Helpers.Locations.addParameter(
            redirectUrl,
            paramKey,
            paramVal
          );
        }
      }
      window.open(redirectUrl, "_blank");
    } else {
      const {
        isbn = Object.keys(Fraction.User.contextTokens)[0],
        label
      } = params;
      const launchParams = {
        brand_key: Fraction.Brand.jigsawBrand,
        ...params,
        type: type,
        isbn: isbn,
        roles: roles
      };
      Jigsaw.User.createLTILaunch(launchParams, response => {
        if (response.isSuccess()) {
          window.location = response.data.redirect_url;
        } else {
          toastUtils.notify({
            title: i18n.t("lti.no-access", { label }),
            children: (
              <span>
                {i18n.t("lti.support")}
                <a
                  href={Fraction.Brand.Support.url}
                  title="Support"
                  target="_blank"
                >
                  {i18n.t("lti.contact-support")}
                </a>
              </span>
            )
          });
        }
      });
    }
  }
};

// DUPLICATE, use redux/router/utils
export const isRelativeURL = dest => {
  const url = _getURL(dest);
  return (
    (url.hostname === window.location.hostname || url.hostname === "") &&
    (window.location.protocol === url.protocol || url.protocol === "")
  );
};

export const requiresRedirectWarning = (destination, isSafe) => {
  const protocol = _getProtocol(destination);
  const trustedProtocol = _allowListedProtocols.indexOf(protocol) !== -1;

  if (protocol && !trustedProtocol && !isSafe) {
    return true;
  }

  if (destination && !isRelativeURL(destination)) {
    try {
      const hostname = _getHostname(destination);

      if (!isSafe) {
        // consider this safe, we cannot have crazy things happening with vbk://
        const domain = _getDomain(hostname);
        const currentDomain = _getDomain(window.location.hostname);
        const trustedDomain =
          domain === currentDomain || _allowlistDomain.indexOf(domain) !== -1;
        return !trustedProtocol || !trustedDomain;
      }
    } catch (e) {
      // probably an invalid url, return true
      return true;
    }
  }
  return false;
};

export const safeRedirect = (destination, windowOpen, isSafe, returnHref) => {
  if (requiresRedirectWarning(destination, isSafe)) {
    destination = `/#/redirect/${encodeURIComponent(destination)}`;
  }

  if (returnHref) {
    return destination;
  }
  if (windowOpen) {
    return window.open(destination, windowOpen);
  } else {
    return window.location.assign(destination);
  }
};

export const ssoToOldOnlineURL = (dest, newtab, user, old, returnHref) => {
  if (user && user.email) {
    var redirectUrl = `/#/redirect/${encodeURIComponent(dest)}`;
    redirectUrl = addParameter(redirectUrl, "sso", "true");
    if (old) {
      redirectUrl = addParameter(redirectUrl, "old", "true");
    }
    if (returnHref) {
      return redirectUrl;
    }
    if (newtab) {
      window.open(redirectUrl, "_blank");
    } else {
      window.location.assign(redirectUrl);
    }
  } else {
    if (newtab) {
      safeRedirect(dest, "_blank");
    } else {
      safeRedirect(dest);
    }
  }
};

export const storeAndRedirect = (
  dest,
  redirectAfterSignIn,
  queryAfterSignIn
) => {
  Fraction.redirectAfterSignIn = redirectAfterSignIn;
  Fraction.queryAfterSignIn = queryAfterSignIn;
  Fraction.Router.setRoute(dest);
  //setItem("redirectAfterSignIn", JSON.stringify(Fraction.redirectAfterSignIn));
  //setItem("queryAfterSignIn", JSON.stringify(Fraction.queryAfterSignIn));
};
